export default function SavedFiltersDeleteModalController(
	$scope,
	$rootScope,
	$uibModalInstance,
	gettextCatalog,
	savedFilterId,
	savedFilterService
) {
    'ngInject';

	$scope.savedFilterId = savedFilterId;
	var userId = $rootScope.currentUser.id;

	$scope.loading = false; //change back to true when we have service working
	$scope.errorFlag = false;
	$scope.errorText = '';
	$scope.deleting = false;

	$scope.deleteFilter = function() {
		$scope.deleting = true;
		savedFilterService
			.deleteSavedFilter($scope.savedFilterId)
			.then(function() {
				$scope.deleting = false;
				return savedFilterService.getAllSavedFilters(userId);
			})
			.then(function(response) {
				$scope.loading = true;

				if (!response) {
					return;
				}

				$scope.savedFiltersModels = response.data.reverse();
				$scope.deleting = false;
				$scope.finish();
			})
			.catch(function(error) {
				var errorMsg = gettextCatalog.getString(
					'An error occurred while retrieving Saved Filter information. Please try again later.'
				);
				if (error) {
					if (!!error.data && !!error.data.message && !!error.status && !!error.statusText) {
						errorMsg = error.data.message + ' ' + (error.status.toString() + ' - ' + error.statusText.toString());
					} else if (!!error.status && !!error.statusText) {
						errorMsg =
							gettextCatalog.getString('An error occurred while retrieving Saved Filter information: ') +
							(error.status.toString() + ' - ' + error.statusText.toString());
					}
				}
				$scope.errorFlag = true;
				$scope.errorText = errorMsg;
				$scope.deleting = false;
			});
	};

	$scope.finish = function() {
		$uibModalInstance.close($scope.savedFiltersModels);
	};

	$scope.cancel = function() {
		$uibModalInstance.dismiss('cancel');
	};

	$scope.$on('$locationChangeStart', function(event) {
		event.preventDefault();
	});
}
